module.exports = __webpack_public_path__ + "media/images/sala_reuniao-129a79c0f38d4fc138423ccadd26b345.svg";